/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Description_PlaceholderInputs */

const en_explorer_info_description_placeholder = /** @type {(inputs: Explorer_Info_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add notes about this record`)
};

const fr_explorer_info_description_placeholder = /** @type {(inputs: Explorer_Info_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add notes about this record`)
};

const de_explorer_info_description_placeholder = /** @type {(inputs: Explorer_Info_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add notes about this record`)
};

const it_explorer_info_description_placeholder = /** @type {(inputs: Explorer_Info_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add notes about this record`)
};

const ru_explorer_info_description_placeholder = /** @type {(inputs: Explorer_Info_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add notes about this record`)
};

const es_explorer_info_description_placeholder = /** @type {(inputs: Explorer_Info_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add notes about this record`)
};

const zh_cn2_explorer_info_description_placeholder = /** @type {(inputs: Explorer_Info_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add notes about this record`)
};

const ja_explorer_info_description_placeholder = /** @type {(inputs: Explorer_Info_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add notes about this record`)
};

const hi_explorer_info_description_placeholder = /** @type {(inputs: Explorer_Info_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add notes about this record`)
};

const pt_pt2_explorer_info_description_placeholder = /** @type {(inputs: Explorer_Info_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add notes about this record`)
};

/**
* | output |
* | --- |
* | "Add notes about this record" |
*
* @param {Explorer_Info_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_description_placeholder = /** @type {((inputs?: Explorer_Info_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Description_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_description_placeholder(inputs)
	if (locale === "de") return de_explorer_info_description_placeholder(inputs)
	if (locale === "it") return it_explorer_info_description_placeholder(inputs)
	if (locale === "ru") return ru_explorer_info_description_placeholder(inputs)
	if (locale === "es") return es_explorer_info_description_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_description_placeholder(inputs)
	if (locale === "ja") return ja_explorer_info_description_placeholder(inputs)
	if (locale === "hi") return hi_explorer_info_description_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_description_placeholder(inputs)
	return en_explorer_info_description_placeholder(inputs)
});